import { useContext } from 'react';
import { AppContext } from '../containers/App/context';

function useUserOrganizationId(): string {
  const { userOrganizationId } = useContext(AppContext);
  return userOrganizationId;
}

export default useUserOrganizationId;
